var max = Math.max;
var min = Math.min;
var round = Math.round;
export {
  max,
  min,
  round
};
//# sourceMappingURL=math.es.js.map
